import { ChangeEvent, useMemo } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  SelectChangeEvent,
} from '@mui/material';
import { Box } from '@mui/system';
import debounce from '@mui/utils/debounce';
import { StyledTextField } from 'components/Inputs';
import { useTranslation } from 'react-i18next';
import { FiltersProps, PaymentStatus } from './filters.types';

export const ClientFilters = ({ params, setParams }: FiltersProps) => {
  const { t } = useTranslation(['misc', 'invoice', 'reports']);

  const { startDate, endDate, status } = params;
  const handleDateChange =
    (filterType: string) => (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.value) {
        setParams((prev) => ({
          ...prev,
          [filterType]: new Date(event.target.value),
        }));
      }
    };

  const handleSelectChange =
    (filterType: string) => (event: SelectChangeEvent<any>) =>
      setParams((prev) => ({
        ...prev,
        [filterType]: event.target.value,
      }));

  const debouncedSearch = useMemo(
    () =>
      debounce(
        (e: ChangeEvent<HTMLInputElement>) =>
          setParams((prev) => ({ ...prev, filterText: e.target.value })),
        500,
      ),
    [],
  );

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      paddingBottom={1.5}
      paddingX={2.25}
      paddingTop={3}
      minWidth='600px'
      style={{ fontSize: '0.925rem' }}
    >
      <div>
        <Box>
          <StyledTextField
            id='date'
            size='small'
            label={t('startDate', { ns: 'misc' })}
            type='date'
            width={170}
            onChange={handleDateChange('startDate')}
            value={startDate!.toISOString().slice(0, 10)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <StyledTextField
            id='date'
            size='small'
            label={t('endDate', { ns: 'misc' })}
            type='date'
            width={170}
            onChange={handleDateChange('endDate')}
            value={endDate!.toISOString().slice(0, 10)}
            sx={{ marginLeft: '10px' }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <FormControl sx={{ marginLeft: '20px' }} size='small'>
            <InputLabel id='Status-label'>
              {t('invoice.status.label', { ns: 'reports' })}
            </InputLabel>
            <Select
              labelId='Status-label'
              value={status}
              onChange={handleSelectChange('status')}
              label={t('invoice.status.label', { ns: 'reports' })}
              sx={{ minWidth: '100px', color: 'black' }}
            >
              <MenuItem value={PaymentStatus.ALL}>
                {t('invoicePublished.label', { ns: 'invoice' })}
              </MenuItem>
              <MenuItem value={PaymentStatus.PAID}>
                {t('invoiceStatus.PAID', { ns: 'invoice' })}
              </MenuItem>
              <MenuItem value={PaymentStatus.REQUIRE_PAYMENT}>
                {t('invoiceStatus.NOT_PAID', { ns: 'invoice' })}
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      </div>

      <TextField
        placeholder={t('button.search', { ns: 'misc' })}
        type='text'
        size='small'
        onChange={debouncedSearch}
      />
    </Box>
  );
};
